import React, { useState } from 'react';
import DetallePago from '../componets/DetallePago';
import Confirmacion from '../componets/Confirmacion';
import Common from '../componets/Common';

export const PagoWebPage = () => {
  const [estadoApp, setEstadoApp] = useState({
    idComercio: `${Common.merchandId}`,
    viewDetalle: true,
    viewConfimar: false,
    viewPagoEfectivo: false,
    orden: "",
    mensaje: "",
    fecha: "",
    jwt: "",
});

const handleConfirmar = (orden, mensaje, fecha, jwt) => {
  setEstadoApp({
    ...estadoApp,
    viewConfimar: true,
    viewDetalle: false,
    viewPagoEfectivo: false,
    orden: orden,
    mensaje: mensaje,
    fecha: fecha,
    jwt: jwt,
    tarjeta: "",
    tipotarjeta: "",
  });
};

const handleValidar = (orden, mensaje, fecha, jwt, tipotarjeta, tarjeta) => {
  setEstadoApp({
    ...estadoApp,
    viewConfimar: true,
    viewDetalle: false,
    viewPagoEfectivo: false,
    orden: orden,
    mensaje: mensaje,
    fecha: fecha,
    jwt: jwt,
    tarjeta: tarjeta,
    tipotarjeta: tipotarjeta,
  });
};

return estadoApp.viewDetalle && !estadoApp.viewConfimar ? (
  <DetallePago
    idComercio={estadoApp.idComercio}
    handleConfirmar={handleConfirmar}
    handleValidar={handleValidar}
  ></DetallePago>
) : (
  <Confirmacion
    idComercio={estadoApp.idComercio}
    orden={estadoApp.orden}
    mensaje={estadoApp.mensaje}
    fecha={estadoApp.fecha}
    jwt={estadoApp.jwt}
    tarjeta={estadoApp.tarjeta}
    tipotarjeta={estadoApp.tipotarjeta}
  ></Confirmacion>
);
}
